import React from "react";
import styles from "./styles.module.scss";
import useTranslation from "next-translate/useTranslation";
import { ABOUT_NAMESPACE } from "../../../../utils/i18nNameSpaces";

const Index = () => {
  const { t } = useTranslation(ABOUT_NAMESPACE);
  return (
    <section className={styles["first-block"]}>
      <div className={styles["container"]}>
        <div className={styles["content"]}>
          <h1 className={styles["header"]}>{t("firstBlock.header")}</h1>
          <p className={styles["subheader"]}>{t("firstBlock.subheader")}</p>
        </div>
      </div>
    </section>
  );
};

export default Index;
